import { render, staticRenderFns } from "./electric-icon-box.vue?vue&type=template&id=056d8b4a&scoped=true&"
import script from "./electric-icon-box.vue?vue&type=script&lang=js&"
export * from "./electric-icon-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056d8b4a",
  null
  
)

export default component.exports